const translitMap = {
  'A': 'А', 'B': 'Б', 'V': 'В', 'W': 'В', 'G': 'Г', 'D': 'Д', 'E': 'Е',
  'Jo': 'Ё', 'JO': 'Ё', 'Yo': 'Ё', 'YO': 'Ё', 'Ö': 'Ё',
  'Zh': 'Ж', 'ZH': 'Ж', 'Z': 'З', 'I': 'И', 'J': 'Й',
  'K': 'К', 'L': 'Л', 'M': 'М', 'N': 'Н', 'O': 'О', 'P': 'П', 'R': 'Р',
  'S': 'С', 'T': 'Т', 'U': 'У', 'F': 'Ф',
  'H': 'Х', 'X': 'Х', 'C': 'Ц', 'Ch': 'Ч', 'CH': 'Ч',
  'Sh': 'Ш', 'SH': 'Ш', 'Shh': 'Щ', 'SHH': 'Щ',
  '##': 'Ъ', 'Y': 'Ы', "'": 'ь',
  'Je': 'Э', 'JE': 'Э', 'Ä': 'Э',
  'Ju': 'Ю', 'JU': 'Ю', 'Yu': 'Ю', 'YU': 'Ю', 'Ü': 'Ю',
  'Ja': 'Я', 'JA': 'Я', 'Ya': 'Я', 'YA': 'Я',
  'a': 'а', 'b': 'б', 'v': 'в', 'w': 'в', 'g': 'г', 'd': 'д', 'e': 'е',
  'jo': 'ё', 'yo': 'ё', 'ö': 'ё',
  'zh': 'ж', 'z': 'з', 'i': 'и', 'j': 'й',
  'k': 'к', 'l': 'л', 'm': 'м', 'n': 'н', 'o': 'о', 'p': 'п', 'r': 'р',
  's': 'с', 't': 'т', 'u': 'у', 'f': 'ф',
  'h': 'х', 'x': 'х', 'c': 'ц', 'ch': 'ч',
  'sh': 'ш', 'shh': 'щ',
  '#': 'ъ', 'y': 'ы',
  'je': 'э', 'ä': 'э',
  'ju': 'ю', 'yu': 'ю', 'ü': 'ю',
  'ja': 'я', 'ya': 'я'
};

export function transliterateWithMapping(inputText, caretPosition) {

  const translitMap = {
    // 'щ'
    'shh': 'щ',
    'шh': 'щ',
    'схh': 'щ',
    // 'ё'
    'jo': 'ё',
    'йo': 'ё',
    'yo': 'ё',
    'ыo': 'ё',
    // 'ж'
    'zh': 'ж',
    'зh': 'ж',
    // 'ч'
    'ch': 'ч',
    'цh': 'ч',
    // 'ш'
    'sh': 'ш',
    'сh': 'ш',
    // 'э'
    'je': 'э',
    'йe': 'э',
    // 'ю'
    'ju': 'ю',
    'йu': 'ю',
    'yu': 'ю',
    'ыu': 'ю',
    //  'я'
    'ja': 'я',
    'йa': 'я',
    'ya': 'я',
    'ыa': 'я',
    // 'Ъ'
    '##': 'Ъ',
    'ъ#': 'Ъ',
    // single chars
    'a': 'а',
    'b': 'б',
    'v': 'в',
    'w': 'в',
    'g': 'г',
    'd': 'д',
    'e': 'е',
    'ö': 'ё',
    'z': 'з',
    'i': 'и',
    'j': 'й',
    'k': 'к',
    'l': 'л',
    'm': 'м',
    'n': 'н',
    'o': 'о',
    'p': 'п',
    'r': 'р',
    's': 'с',
    't': 'т',
    'u': 'у',
    'f': 'ф',
    'h': 'х',
    'x': 'х',
    'c': 'ц',
    '#': 'ъ',
    'y': 'ы',
    "'": 'ь',
    'ä': 'э',
    'ü': 'ю',
  };

  // Split the input text into left and right parts
  const leftText = inputText.slice(0, caretPosition);
  const rightText = inputText.slice(caretPosition);

  let transliteratedLeftText = '';
  let i = 0;
  while (i < leftText.length) {
    let matchFound = false;
    // Maximum key length in translitMap is 3
    const maxKeyLength = 3;
    for (let len = Math.min(maxKeyLength, leftText.length - i); len >= 1; len--) {
      const substr = leftText.substr(i, len).toLowerCase();
      if (translitMap[substr]) {
        // Preserve original case
        const originalSubstr = leftText.substr(i, len);
        const translitChar = translitMap[substr];
        // Adjust case
        let translitCharWithCase = translitChar;
        if (isUpperCase(originalSubstr[0])) {
          translitCharWithCase = translitChar.charAt(0).toUpperCase() + translitChar.slice(1);
        }
        transliteratedLeftText += translitCharWithCase;
        i += len;
        matchFound = true;
        break;
      }
    }
    if (!matchFound) {
      transliteratedLeftText += leftText[i];
      i++;
    }
  }

  const transliteratedText = transliteratedLeftText + rightText;
  const newCaretPosition = transliteratedLeftText.length;

  return { transliteratedText, newCaretPosition };
}

function isUpperCase(char) {
  return char === char.toUpperCase() && char !== char.toLowerCase();
}

export const transliterate = (input) => {
  let result = '';
  let i = 0;

  while (i < input.length) {
    let match = '';
    for (let j = 3; j > 0; j--) {
      const subStr = input.substr(i, j);
      if (translitMap[subStr] !== undefined) {
        match = subStr;
        break;
      }
    }
    if (match) {
      result += translitMap[match];
      i += match.length;
    } else {
      result += input[i];
      i++;
    }
  }

  return result;
};